module.exports = __webpack_public_path__ + "img/logo.2ff04b3c.svg";